import { historyTabsActions } from '../actions'
import { HISTORY_TABS } from '../constants'
import { useActions, useAppSelector } from '../../../store/hooks'
import { historyPageSelector } from '../../../store/slices/historyPage'

const TAB_ITEMS = [
    { id: HISTORY_TABS.export, label: 'Экспорт расписания' },
    { id: HISTORY_TABS.versions, label: 'История версий расписания' },
    { id: HISTORY_TABS.audit, label: 'Журнал изменений' },
]

export function useHistoryTabs() {
    const activeTab = useAppSelector(historyPageSelector.activeTab)
    const { setActiveTab } = useActions(historyTabsActions)

    return {
        activeTab,
        tabs: TAB_ITEMS,
        setActiveTab,
    }
}
